/* Eznzza · "Completá tu rutina" en el carrito lateral.
   Carrusel debajo de los productos del carrito. Fuentes, en orden:
   1) complementarios de los productos del carrito (Search & Discovery),
   2) productos de la misma marca (sections/cyr-fallback.liquid),
   3) productos relacionados.
   No muestra lo que ya está en el carrito. "+" agrega sin cerrar el carrito.
   Tarjetas: snippets/cyr-card.liquid (las mismas de la ficha). */
(function () {
  if (window.__ccy) return;
  window.__ccy = true;

  var TTL = 10 * 60 * 1000;
  var MAX = 10;
  var BRANDS = ['Makeup by Mario', 'Patrick Ta', 'Charlotte Tilbury', 'Rare Beauty', 'Rhode'];
  var mem = {};
  var lastLeft = 0;

  function norm(s) { return (s || '').toLowerCase().trim(); }
  function money(c) {
    return '$' + (Math.round(c) / 100).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function brandOf(it) {
    var v = norm(it.vendor);
    if (v && v !== 'eznzza') return it.vendor;
    var t = norm(it.product_title);
    for (var i = 0; i < BRANDS.length; i++) {
      if (t.indexOf(norm(BRANDS[i])) === 0) return BRANDS[i];
    }
    return '';
  }

  /* Pide una sección y devuelve solo el HTML de las tarjetas (con caché corta) */
  function getCards(url) {
    if (mem[url]) return mem[url];
    var key = 'ccy:' + url;
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < TTL) return (mem[url] = Promise.resolve(c.h));
    } catch (e) {}
    mem[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var h = Array.from(d.querySelectorAll('[data-cyr-card]')).map(function (n) { return n.outerHTML; }).join('');
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), h: h })); } catch (e) {}
        return h;
      })
      .catch(function () { delete mem[url]; return ''; });
    return mem[url];
  }
  function toNodes(h) {
    if (!h) return [];
    var box = document.createElement('template');
    box.innerHTML = h;
    return Array.from(box.content.querySelectorAll('[data-cyr-card]'));
  }

  async function pick(items) {
    var inCart = {}, cartTypes = {}, pids = [], brands = [];
    items.forEach(function (it) {
      var p = String(it.product_id);
      if (!inCart[p]) pids.push(p);
      inCart[p] = true;
      cartTypes[norm(it.product_type)] = true;
      var b = brandOf(it);
      if (b && brands.indexOf(b) === -1) brands.push(b);
    });
    var picks = [], seen = {};
    function push(list, ok) {
      list.forEach(function (c) {
        var p = c.dataset.pid;
        if (picks.length >= MAX || inCart[p] || seen[p]) return;
        if (ok && !ok(c)) return;
        seen[p] = true;
        picks.push(c);
      });
    }
    var rec = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
    var ids = pids.slice(0, 4);

    /* 1) Complementarios, alternando entre los productos del carrito */
    var comp = await Promise.all(ids.map(function (p) {
      return getCards(rec + '?product_id=' + p + '&limit=6&intent=complementary&section_id=cart-cyr').then(toNodes);
    }));
    for (var i = 0; i < 6; i++) push(comp.map(function (l) { return l[i]; }).filter(Boolean));

    /* 2) Misma marca: primero otras categorías que las del carrito */
    if (picks.length < 4 && brands.length) {
      var byBrand = await Promise.all(brands.slice(0, 2).map(function (b) {
        return getCards('/search?q=' + encodeURIComponent(b) + '&type=product&options%5Bprefix%5D=last&section_id=cyr-fallback')
          .then(toNodes)
          .then(function (l) {
            var nb = norm(b);
            return l.filter(function (c) { return norm(c.dataset.vendor) === nb || norm(c.dataset.title).indexOf(nb) === 0; });
          });
      }));
      var usedTypes = {};
      byBrand.forEach(function (l) {
        push(l, function (c) {
          var t = norm(c.dataset.type);
          if (cartTypes[t] || usedTypes[t] || picks.length >= 6) return false;
          usedTypes[t] = true;
          return true;
        });
      });
      byBrand.forEach(function (l) { if (picks.length < 6) push(l, function (c) { return !cartTypes[norm(c.dataset.type)]; }); });
      byBrand.forEach(function (l) { if (picks.length < 6) push(l); });
    }

    /* 3) Relacionados */
    if (picks.length < 4 && ids[0]) {
      push(await getCards(rec + '?product_id=' + ids[0] + '&limit=10&intent=related&section_id=cart-cyr').then(toNodes));
    }
    return picks;
  }

  var ICON_PLUS = '<svg class="ccy-i-plus" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_CHECK = '<svg class="ccy-i-check" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setupCard(card, root) {
    var chk = card.querySelector('[data-cyr-check]');
    var title = (card.querySelector('.cyr-title') || {}).textContent || '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ccy-add';
    btn.dataset.vid = chk ? chk.value : '';
    btn.setAttribute('aria-label', 'Agregar ' + title.trim() + ' al carrito');
    btn.innerHTML = ICON_PLUS + ICON_CHECK;
    var lab = chk && chk.closest('label');
    if (lab) lab.remove();
    card.appendChild(btn);
    var sel = card.querySelector('[data-cyr-select]');
    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        btn.dataset.vid = opt.value;
        var price = card.querySelector('[data-cyr-price]');
        if (price && opt.dataset.price) price.textContent = money(Number(opt.dataset.price));
        var img = card.querySelector('[data-cyr-img]');
        if (img && opt.dataset.img) img.src = opt.dataset.img;
      });
    }
    btn.addEventListener('click', function () { add(btn, root); });
  }

  async function add(btn, root) {
    if (!btn.dataset.vid || btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;
    var msg = root.querySelector('.ccy-msg');
    if (msg) msg.hidden = true;
    btn.classList.add('is-loading');
    var cart = document.querySelector('cart-drawer');
    var body = new FormData();
    body.append('id', btn.dataset.vid);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }
    try {
      var res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      var data = await res.json();
      btn.classList.remove('is-loading');
      if (data.status) {
        if (msg) { msg.textContent = data.description || data.message || 'No se pudo agregar al carrito.'; msg.hidden = false; }
        return;
      }
      btn.classList.add('is-done');
      btn.setAttribute('aria-label', 'Agregado al carrito');
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-cyr' });
      /* Un instante con el ✓ y se actualiza el carrito (queda abierto) */
      setTimeout(function () {
        if (cart && typeof cart.renderContents === 'function') cart.renderContents(data);
        else window.location = (window.routes && window.routes.cart_url) || '/cart';
      }, 650);
    } catch (e) {
      btn.classList.remove('is-loading');
      if (msg) { msg.textContent = 'No se pudo agregar al carrito.'; msg.hidden = false; }
    }
  }

  /* Flechas y puntos */
  function nav(root) {
    var track = root.querySelector('.ccy-track');
    var prev = root.querySelector('.ccy-prev');
    var next = root.querySelector('.ccy-next');
    var dotsBox = root.querySelector('.ccy-dots');
    var dots = [];
    function step() {
      var c = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c ? c.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function positions() {
      var n = track.children.length;
      var visible = Math.max(1, Math.floor((track.clientWidth + 4) / step()));
      return Math.max(1, n - visible + 1);
    }
    function build() {
      var n = positions();
      root.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
      dotsBox.innerHTML = '';
      dots = [];
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Ir al producto ' + (i + 1));
        (function (idx) { d.addEventListener('click', function () { track.scrollTo({ left: idx * step(), behavior: 'smooth' }); }); })(i);
        dotsBox.appendChild(d);
        dots.push(d);
      }
      update();
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      var idx = track.scrollLeft >= max - 2 ? dots.length - 1 : Math.round(track.scrollLeft / step());
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var raf;
    track.addEventListener('scroll', function () {
      lastLeft = track.scrollLeft;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(build).observe(track);
    build();
  }

  function skeleton() {
    return '<div class="ccy-skel"></div><div class="ccy-skel"></div>';
  }

  async function mount(anchor) {
    var root = document.createElement('div');
    root.className = 'ccy';
    root.setAttribute('data-cart-cyr', '');
    root.innerHTML =
      '<div class="ccy-head"><p class="ccy-title">Completá tu rutina</p>' +
      '<div class="ccy-nav"><button type="button" class="ccy-prev" aria-label="Anterior"></button>' +
      '<button type="button" class="ccy-next" aria-label="Siguiente"></button></div></div>' +
      '<div class="ccy-track" aria-busy="true">' + skeleton() + '</div>' +
      '<div class="ccy-dots"></div><p class="ccy-msg" role="status" hidden></p>';
    anchor.insertAdjacentElement('afterend', root);
    try {
      var cart = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      if (!root.isConnected) return;
      var picks = cart.items && cart.items.length ? await pick(cart.items) : [];
      if (!root.isConnected) return;
      if (!picks.length) { root.remove(); return; }
      var track = root.querySelector('.ccy-track');
      track.innerHTML = '';
      picks.forEach(function (c, i) {
        var card = c.cloneNode(true);
        var img = card.querySelector('img');
        if (img && i < 3) img.loading = 'eager';
        track.appendChild(card);
        setupCard(card, root);
      });
      track.removeAttribute('aria-busy');
      root.classList.add('is-ready');
      nav(root);
      if (lastLeft) track.scrollLeft = lastLeft;
    } catch (e) {
      root.remove();
    }
  }

  function scan() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !(drawer.classList.contains('is-visible') || drawer.hasAttribute('open'))) return;
    var anchor = drawer.querySelector('.cart-content-items');
    if (!anchor || drawer.querySelector('[data-cart-cyr]')) return;
    mount(anchor);
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(scan).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
